<template>
  <div class="bitts-progress-bar">
    <div
      class="bitts-progress-bar__fill"
      data-testid="progress-bar-fill"
      :class="foregroundColor"
      :style="{
        width,
        maxWidth: '100%',
      }"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

type BittsProgressBarColor =
  | 'danger'
  | 'warning'
  | 'neutral'
  | 'secondary'
  | 'brand'
  | 'success';

type BittsProgressBarProps = {
  width?: string;
  height?: number;
  color?: BittsProgressBarColor;
};

const {
  width = '0%',
  height = 8,
  color = 'neutral',
} = defineProps<BittsProgressBarProps>();

const colorClasses: Record<BittsProgressBarColor, string> = {
  danger: 'bg-danger-accent',
  warning: 'bg-warning-accent',
  neutral: 'bg-neutral-accent',
  secondary: 'bg-secondary-accent',
  brand: 'bg-brand-teal',
  success: 'bg-success-accent',
};

const foregroundColor = computed(() => colorClasses[color]);
const computedHeight = computed(() => `${height}px`);
</script>

<style scoped lang="pcss">
@reference "../../../../apps/crossbeam-app/src/css/theme.css";
.bitts-progress-bar {
  @apply rounded-full relative w-full bg-neutral-background;
  height: v-bind(computedHeight);
}

.bitts-progress-bar__fill {
  @apply h-full rounded-full;
}
</style>
